import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e576358"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  id: "com_form_contet1"
}
const _hoisted_3 = { class: "errorform" }
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}
const _hoisted_5 = {
  key: 2,
  id: "contents1"
}
const _hoisted_6 = { class: "com_sec1" }
const _hoisted_7 = { class: "com_inner1 clearfix" }
const _hoisted_8 = { class: "com_utl1" }
const _hoisted_9 = { class: "com_date1 roboto" }
const _hoisted_10 = { class: "com_category1" }
const _hoisted_11 = {
  key: 0,
  class: "com_new1 roboto"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "参照新規"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "参照新規")
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "修正"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "修正")
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "error-message"
}
const _hoisted_18 = { class: "com_d_title1" }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 3,
  class: "com_links1"
}
const _hoisted_22 = {
  key: 0,
  class: "item1"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "リンク")
], -1))
const _hoisted_24 = ["href", "onClick"]
const _hoisted_25 = ["href", "onClick"]
const _hoisted_26 = {
  key: 1,
  class: "item1"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "文書ファイル", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全データダウンロード", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["href", "onClick"]
const _hoisted_31 = {
  key: 0,
  class: "sub1"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ダウンロード", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 4,
  class: "com_d_content1"
}
const _hoisted_36 = ["src", "alt"]
const _hoisted_37 = {
  key: 5,
  style: {"text-align":"center"}
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "com_check_comp2" }
const _hoisted_40 = ["value", "checked"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "checkComplete" }, "完了", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "戻る"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "戻る")
], -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "閉じる"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "閉じる")
], -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_BreadcrumbsComponent = _resolveComponent("BreadcrumbsComponent")!
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_HeaderComponent)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.apiErrorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.apiErrorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isCategoryIdFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.isCategoryIdFetched && !_ctx.isPreview)
                ? (_openBlock(), _createBlock(_component_BreadcrumbsComponent, {
                    key: 0,
                    title: _ctx.contentsData.title,
                    categoryId: _ctx.contentsData.categoryId
                  }, null, 8, ["title", "categoryId"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.contentsData.keisaiKikanStart), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.contentsData.subCategoryName), 1),
                  (_ctx.contentsData.newFlg)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "NEW"))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.isPreview)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_ctx.isKaunetAdmin)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
                _ctx.copyContents(_ctx.contentsData.categoryId, _ctx.contentsData.contentsId)
              ), ["prevent"])),
                            class: "com_s_button1"
                          }, _hoisted_14))
                        : _createCommentVNode("", true),
                      (_ctx.isKaunetAdmin)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: "#",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
                _ctx.editContents(_ctx.contentsData.categoryId, _ctx.contentsData.contentsId)
              ), ["prevent"])),
                            class: "com_s_button2"
                          }, _hoisted_16))
                        : _createCommentVNode("", true),
                      (_ctx.contentsData.isFavorite)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: "com_favorite1 selected",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleToggleFavorite(_ctx.contentsData)))
                          }))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 3,
                            class: "com_favorite1",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleToggleFavorite(_ctx.contentsData)))
                          }))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("h1", _hoisted_18, _toDisplayString(_ctx.contentsData.title), 1),
              (_ctx.contentsData.contentsVideoList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.contentsData.contentsVideoList[0].videoExp), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.containerClass)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsVideoList, (videoData, index) => {
                        return (_openBlock(), _createBlock(_component_VideoPlayer, {
                          key: videoData.rowNo,
                          videoSrc: `/${videoData.videoPath}/${videoData.videoName}`,
                          contentsId: _ctx.contentsData.contentsId,
                          screenName: "コンテンツ詳細",
                          class: _normalizeClass(_ctx.playerClass(index)),
                          onHalfWatched: _ctx.handleHalfWatched
                        }, null, 8, ["videoSrc", "contentsId", "class", "onHalfWatched"]))
                      }), 128))
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "ql-editor",
                innerHTML: _ctx.sanitizedContent
              }, null, 8, _hoisted_20),
              (_ctx.isExistsLinkAreaItem)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_ctx.contentsData.contentsLinkList.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsLinkList, (link) => {
                              return (_openBlock(), _createElementBlock("ul", {
                                key: link.rowNo,
                                class: "list1"
                              }, [
                                _createElementVNode("li", null, [
                                  (_ctx.isInternalLink(link.url))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: `${link.url}`,
                                        class: "com_link1",
                                        onClick: ($event: any) => (_ctx.regLinkClick(link.url))
                                      }, _toDisplayString(link.caption || link.url), 9, _hoisted_24))
                                    : (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        href: `${link.url}`,
                                        class: "com_link1",
                                        target: "_blank",
                                        onClick: ($event: any) => (_ctx.regLinkClick(link.url))
                                      }, _toDisplayString(link.caption || link.url), 9, _hoisted_25))
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.contentsData.contentsTempFileList.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("div", null, [
                            _hoisted_27,
                            _createElementVNode("a", {
                              href: "#",
                              class: "com_dl_button1",
                              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (
                  _ctx.downloadFiles(
                    _ctx.contentsData.categoryId,
                    _ctx.contentsData.contentsId,
                    ''
                  )
                ), ["prevent"]))
                            }, _hoisted_29)
                          ]),
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsTempFileList, (tmpFile) => {
                              return (_openBlock(), _createElementBlock("ul", {
                                key: tmpFile.rowNo,
                                class: "list2"
                              }, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    href: `/${tmpFile.tempFilePath}/${tmpFile.tempFileName}`,
                                    class: "com_link1",
                                    target: "_blank",
                                    onClick: ($event: any) => (_ctx.regFileLinkClick(tmpFile.tempFileName))
                                  }, _toDisplayString(tmpFile.tempFileName), 9, _hoisted_30),
                                  (tmpFile.tempFileSize)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, " (" + _toDisplayString(tmpFile.tempFileSize) + ")", 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "com_dl_button2",
                                    onClick: _withModifiers(($event: any) => (
                      _ctx.downloadFiles(
                        _ctx.contentsData.categoryId,
                        _ctx.contentsData.contentsId,
                        tmpFile.tempFileName
                      )
                    ), ["prevent"])
                                  }, _hoisted_34, 8, _hoisted_32)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.contentsData.contentsImgList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsImgList, (imgFile) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: imgFile.rowNo
                      }, [
                        _createElementVNode("img", {
                          src: `/${imgFile.imgPath}/${imgFile.imgName}`,
                          alt: imgFile.imgExp
                        }, null, 8, _hoisted_36)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isPreview)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    (_ctx.isSkilupCategory)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              id: "checkComplete",
                              name: "",
                              value: _ctx.isWatched,
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateWatchedStatus())),
                              checked: _ctx.isWatched
                            }, null, 40, _hoisted_40),
                            _hoisted_41
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isPreview && !_ctx.isModal)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 6,
                    href: "#",
                    class: "com_b_button1",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goback && _ctx.goback(...args)), ["prevent"]))
                  }, _hoisted_43))
                : _createCommentVNode("", true),
              (!_ctx.isPreview && _ctx.isModal)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 7,
                    href: "#",
                    class: "com_b_button1",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.frmClose && _ctx.frmClose(...args)), ["prevent"]))
                  }, _hoisted_45))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createVNode(_component_FooterComponent)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isPreview)
      ? (_openBlock(), _createBlock(_component_BackToTop, { key: 4 }))
      : _createCommentVNode("", true)
  ], 64))
}